import { render, staticRenderFns } from "./JdsDialog.vue?vue&type=template&id=9fe7055a&scoped=true&"
import script from "./JdsDialog.vue?vue&type=script&lang=ts&"
export * from "./JdsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe7055a",
  null
  
)

export default component.exports